"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateManagementDashboard = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var Sidebar_1 = require("Dashboard/Sidebar/Sidebar");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FolderNameInput_1 = require("Dashboard/FolderNameInput/FolderNameInput");
var TemplatePreview_1 = require("./TemplatePreview");
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var TemplateList_1 = require("Dashboard/TemplateListItem/TemplateList");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var useTemplatesDashboardTelemetry_1 = __importStar(require("./useTemplatesDashboardTelemetry"));
var DragLabel_1 = __importDefault(require("Dashboard/DragLabel/DragLabel"));
var SetDragImage_1 = require("Dashboard/SetDragImage");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var InlineOnboarding_1 = __importDefault(require("InlineOnboarding/InlineOnboarding"));
var TemplateFilter_1 = require("Common/Templates/TemplateFilter");
var TemplateSortBySelector_1 = require("Common/Templates/TemplateSortBySelector");
var ArchiveTemplateModal_1 = require("./ArchiveTemplateModal");
var classnames_1 = __importDefault(require("classnames"));
var Telemetry_1 = require("@CommonFrontend/Telemetry");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var AssignmentModal_1 = require("Library/AutomationLibrary/AssignmentModal");
var AutomationsApiService_1 = require("Library/AutomationLibrary/AutomationsApiService");
var useAccountTemplates_1 = __importDefault(require("Common/Templates/useAccountTemplates"));
var c = (0, BemBuilder_1.default)("template-management-dashboard");
var PAGE_SIZE = 25;
var SEARCH_TERM_DEBOUNCE_MS = 1000;
var ASSETS_DIR = "/Assets/";
var TemplateManagementDashboard = function (props) {
    var apiService = props.apiService, dashboardController = props.dashboardController, modalService = props.modalService, selectStyle = props.selectStyle, accountIntegrationsDataStore = props.accountIntegrationsDataStore, notifyUser = props.notifyUser, userList = props.userList, promptsStore = props.promptsStore, usingFeature = props.usingFeature;
    var _a = __read((0, react_1.useState)(undefined), 2), selectedTemplateId = _a[0], selectTemplate = _a[1];
    var _b = __read((0, react_1.useState)(Types_1.TEMPLATES_FIRST_PAGE), 2), page = _b[0], setPage = _b[1];
    var _c = __read((0, react_1.useState)(Types_1.SortField.LastEdited), 2), sortBy = _c[0], setSortBy = _c[1];
    var _d = __read((0, react_1.useState)(Types_1.SortDirection.Descending), 2), sortDirection = _d[0], setSortDirection = _d[1];
    var _e = __read((0, react_1.useState)(Types_1.TemplateCollection.All), 2), collection = _e[0], setCollection = _e[1];
    var _f = __read((0, react_1.useState)(new Set()), 2), templatesWith = _f[0], setTemplatesWith = _f[1];
    var _g = __read((0, react_1.useState)(new Set()), 2), withCrmInfo = _g[0], setCrmInfo = _g[1];
    var telemetry = (0, useTemplatesDashboardTelemetry_1.default)();
    var _h = __read((0, react_1.useState)([]), 2), userFilter = _h[0], setUserFilter = _h[1];
    var _j = __read((0, react_1.useState)(""), 2), searchTerm = _j[0], setSearchTerm = _j[1];
    var _k = __read((0, react_1.useState)(""), 2), debouncedSearchTerm = _k[0], setDebouncedSearchTerm = _k[1];
    var update = (0, AutomationsApiService_1.useAssociations)().update;
    var search = function (searchTerm) {
        setPage(Types_1.TEMPLATES_FIRST_PAGE);
        setDebouncedSearchTerm(searchTerm);
    };
    var debouncedSearch = (0, react_1.useCallback)((0, lodash_1.debounce)(search, SEARCH_TERM_DEBOUNCE_MS), []);
    var onSearchTermChange = function (searchTerm) {
        setSearchTerm(searchTerm);
        debouncedSearch(searchTerm);
    };
    (0, react_1.useEffect)(function () {
        telemetry.templateManagementOpened();
    }, []);
    var accountTemplates = (0, useAccountTemplates_1.default)(props.dashboardController.apiBaseUrl, {
        searchTerm: debouncedSearchTerm,
        page: page,
        pageSize: PAGE_SIZE,
        sortBy: sortBy,
        sortDirection: sortDirection,
        filter: {
            templatesWith: __spreadArray([], __read(templatesWith), false),
            withCrmInfo: __spreadArray([], __read(withCrmInfo), false),
            withUsers: userFilter,
        },
        collection: collection,
        expand: usingFeature(FeatureFlag_1.default.HubspotSyncEssentials) ? Types_1.ExpandOption.Automation : undefined,
    }).accountTemplates;
    var handleCreateTemplate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var template;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, apiService.createTemplate()];
                case 1:
                    template = _a.sent();
                    dashboardController.goToTemplate(template._id, {
                        origin: Telemetry_1.ProjectOpenedOrigin.TemplateManagementDashboard,
                        source: useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.CreateTemplateButton,
                    });
                    return [2];
            }
        });
    }); };
    var onCloseHandler = function () {
        modalService.closeAnyModals();
        selectTemplate(undefined);
    };
    var previewTemplate = function (template, templateOptions) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectTemplate(template._id);
                    telemetry.previewViewed(template._id);
                    return [4, modalService.showSimpleModal({
                            isEscapable: true,
                            containerClassName: "template-preview-modal",
                            body: (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () { return (react_1.default.createElement(TemplatePreview_1.TemplatePreview, { template: template, onModalClose: function () {
                                    telemetry.previewClosed(template._id);
                                    onCloseHandler();
                                }, templateOptions: templateOptions })); })),
                        })];
                case 1:
                    _a.sent();
                    selectTemplate(undefined);
                    return [2];
            }
        });
    }); };
    var openAssignAutomationModal = function (template) { return __awaiter(void 0, void 0, Promise, function () {
        var assignedAutomationIds;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    assignedAutomationIds = (_b = (_a = template.automations) === null || _a === void 0 ? void 0 : _a.automationIds) !== null && _b !== void 0 ? _b : [];
                    telemetry.assignmentModalOpened(template._id, assignedAutomationIds.length);
                    return [4, modalService.showSimpleModal({
                            isEscapable: true,
                            containerClassName: "assign-automation-modal",
                            body: (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () {
                                return (react_1.default.createElement(AssignmentModal_1.AutomationAssignment, { onCancel: function () {
                                        telemetry.assignmentModalCancelled(template._id);
                                        return onCloseHandler();
                                    }, onConfirm: function (automationIds) { return __awaiter(void 0, void 0, Promise, function () {
                                        var e_1;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 3, , 4]);
                                                    return [4, update(template._id, automationIds, "template")];
                                                case 1:
                                                    _a.sent();
                                                    return [4, accountTemplates.mutate()];
                                                case 2:
                                                    _a.sent();
                                                    telemetry.assignmentModalConfirmed(template._id, automationIds.length);
                                                    notifyUser.success("Automation assignment updated!");
                                                    return [3, 4];
                                                case 3:
                                                    e_1 = _a.sent();
                                                    notifyUser.error("Automation assignment cannot be updated. Try again later.");
                                                    return [3, 4];
                                                case 4:
                                                    modalService.closeAnyModals();
                                                    return [2];
                                            }
                                        });
                                    }); }, assignedAutomationIds: assignedAutomationIds, integrationData: {
                                        integration: template.crmInfo.integration,
                                        objectType: template.crmInfo.object,
                                    } }));
                            })),
                        })];
                case 1:
                    _c.sent();
                    return [2];
            }
        });
    }); };
    var editTemplate = function (templateId, source) {
        dashboardController.goToTemplate(templateId, {
            origin: Telemetry_1.ProjectOpenedOrigin.TemplateManagementDashboard,
            source: source,
        });
    };
    var cloneTemplate = function (templateId, templateName, source) { return __awaiter(void 0, void 0, Promise, function () {
        var clonedProjectId_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, 4, 5]);
                    return [4, apiService.cloneTemplate(templateId, templateName)];
                case 1:
                    clonedProjectId_1 = _b.sent();
                    notifyUser.success(react_1.default.createElement(react_1.default.Fragment, null,
                        "Template cloned",
                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                                return dashboardController.goToTemplate(clonedProjectId_1, {
                                    origin: Telemetry_1.ProjectOpenedOrigin.TemplateManagementDashboard,
                                    source: useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.CloneNotificationButton,
                                });
                            } }, "Go to template")));
                    telemetry.templateCloned(templateId, clonedProjectId_1, source);
                    return [4, accountTemplates.mutate()];
                case 2:
                    _b.sent();
                    return [3, 5];
                case 3:
                    _a = _b.sent();
                    notifyUser.error("Template can't be cloned");
                    return [3, 5];
                case 4:
                    onCloseHandler();
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var deleteTemplate = function (templateId, templateName, source) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, modalService.showDeleteModal({
                        confirmLabel: "Delete template",
                        cancelLabel: "Cancel",
                        title: "Delete this template?",
                        explainer: "This will not affect pages you have created using this template. Are you sure you want to delete \"".concat(templateName, "\"?"),
                        isEscapable: true,
                        confirming: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, handleCallback(function () { return apiService.deleteTemplate(templateId); }, "Template successfully deleted", "Template can't be deleted")];
                                    case 1:
                                        _a.sent();
                                        telemetry.templateDeleted(templateId, source);
                                        return [2];
                                }
                            });
                        }); },
                        containerClassName: "",
                    })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var restoreCallback = function (templateId_1, _a, source_1) { return __awaiter(void 0, [templateId_1, _a, source_1], Promise, function (templateId, _b, source) {
        var shouldRestore;
        var confirm = _b.confirm;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    shouldRestore = true;
                    if (!confirm) return [3, 2];
                    return [4, modalService.showConfirmModal({
                            title: "Restore template?",
                            explainer: "This template can't be opened because it's been deleted. Would you like to restore it?",
                            confirmLabel: "Confirm",
                        })];
                case 1:
                    shouldRestore = _c.sent();
                    _c.label = 2;
                case 2:
                    if (!shouldRestore) return [3, 4];
                    return [4, handleCallback(function () { return props.apiService.restoreTemplate(templateId); }, "Template successfully restored", "Template can't be restored")];
                case 3:
                    _c.sent();
                    telemetry.templateRestored(templateId, source);
                    _c.label = 4;
                case 4: return [2];
            }
        });
    }); };
    var archiveCallback = function (templateId, source) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, (0, ArchiveTemplateModal_1.confirmTemplateArchiveWithModal)(modalService, promptsStore, function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, handleCallback(function () { return props.apiService.archiveTemplate(templateId); }, "Template successfully archived", "Template can't be archived")];
                                case 1:
                                    _a.sent();
                                    telemetry.templateArchived(templateId, source);
                                    return [2];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var unArchiveCallback = function (templateId, source) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, handleCallback(function () { return props.apiService.unArchiveTemplate(templateId); }, "Template successfully unarchived", "Template can't be unarchived")];
                case 1:
                    _a.sent();
                    telemetry.templateUnarchived(templateId, source);
                    return [2];
            }
        });
    }); };
    var handleCallback = function (callback, successMsg, errorMsg) { return __awaiter(void 0, void 0, Promise, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, 4, 5]);
                    return [4, callback()];
                case 1:
                    _b.sent();
                    props.notifyUser.success(successMsg);
                    return [4, accountTemplates.mutate()];
                case 2:
                    _b.sent();
                    return [3, 5];
                case 3:
                    _a = _b.sent();
                    props.notifyUser.error(errorMsg);
                    return [3, 5];
                case 4:
                    onCloseHandler();
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var templateListProps = function (collection) {
        switch (collection) {
            case Types_1.TemplateCollection.All:
                return {
                    templates: accountTemplates.data,
                    selectedTemplateId: selectedTemplateId,
                    editCallback: editTemplate,
                    previewCallback: previewTemplate,
                    cloneCallback: cloneTemplate,
                    deleteCallback: deleteTemplate,
                    archiveCallback: archiveCallback,
                    selectStyle: props.selectStyle,
                    onDragStart: startDragging(collection),
                    onDragEnd: stopDragging,
                    pageSize: PAGE_SIZE,
                    openAssignAutomationModal: openAssignAutomationModal,
                };
            case Types_1.TemplateCollection.Deleted:
                return {
                    templates: accountTemplates.data,
                    selectedTemplateId: selectedTemplateId,
                    restoreCallback: restoreCallback,
                    selectStyle: props.selectStyle,
                    onDragStart: startDragging(collection),
                    onDragEnd: stopDragging,
                    pageSize: PAGE_SIZE,
                };
            case Types_1.TemplateCollection.Archived:
                return {
                    templates: accountTemplates.data,
                    selectedTemplateId: "",
                    editCallback: editTemplate,
                    previewCallback: previewTemplate,
                    cloneCallback: cloneTemplate,
                    deleteCallback: deleteTemplate,
                    archiveCallback: unArchiveCallback,
                    archived: true,
                    selectStyle: selectStyle,
                    onDragStart: startDragging(collection),
                    onDragEnd: stopDragging,
                    pageSize: PAGE_SIZE,
                };
        }
    };
    var _l = __read((0, react_1.useState)(null), 2), dragTemplate = _l[0], setDragTemplate = _l[1];
    var dragLabelRef = (0, react_1.useRef)(null);
    var startDragging = function (fromCollection) { return function (event, template) {
        if (dragLabelRef.current) {
            event.dataTransfer.effectAllowed = "move";
            (0, SetDragImage_1.setDragImage)(event, dragLabelRef.current);
            setDragTemplate({ template: template, fromCollection: fromCollection });
        }
    }; };
    var stopDragging = function () {
        setDragTemplate(null);
    };
    var onFolderDrop = function (toCollection) {
        if (!dragTemplate) {
            return;
        }
        var template = dragTemplate.template, fromCollection = dragTemplate.fromCollection;
        if (fromCollection === Types_1.TemplateCollection.All) {
            if (toCollection === Types_1.TemplateCollection.Archived) {
                archiveCallback(template._id, useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.DragAndDrop);
            }
            else if (toCollection === Types_1.TemplateCollection.Deleted) {
                deleteTemplate(template._id, template.name, useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.DragAndDrop);
            }
        }
        else if (fromCollection === Types_1.TemplateCollection.Archived) {
            if (toCollection === Types_1.TemplateCollection.All) {
                unArchiveCallback(template._id, useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.DragAndDrop);
            }
            else if (toCollection === Types_1.TemplateCollection.Deleted) {
                deleteTemplate(template._id, template.name, useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.DragAndDrop);
            }
        }
        else if (fromCollection === Types_1.TemplateCollection.Deleted && toCollection === Types_1.TemplateCollection.All) {
            restoreCallback(template._id, { confirm: false }, useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.DragAndDrop);
        }
    };
    var clearFilters = function () {
        onSearchTermChange("");
        setPage(Types_1.TEMPLATES_FIRST_PAGE);
        setSortBy(Types_1.SortField.LastEdited);
        setSortDirection(Types_1.SortDirection.Descending);
        setTemplatesWith(new Set());
        setCrmInfo(new Set());
        setUserFilter([]);
    };
    var setTemplateCollection = function (collection) {
        clearFilters();
        setCollection(collection);
    };
    return (react_1.default.createElement("div", { className: "dashboard__container" },
        react_1.default.createElement("div", { className: "dashboard__content" },
            react_1.default.createElement("div", { className: "dashboard__sidebar" },
                react_1.default.createElement("div", { className: "dashboard__sidebar-container" },
                    react_1.default.createElement("div", { className: "dashboard-sidebar" },
                        react_1.default.createElement(Sidebar_1.SystemFolder, { dragDropOnFolder: function () { return onFolderDrop(Types_1.TemplateCollection.All); }, name: (0, Types_1.toTemplateCollectionDisplayName)(Types_1.TemplateCollection.All), collection: Types_1.TemplateCollection.All, onFolderSelect: function () { return setTemplateCollection(Types_1.TemplateCollection.All); }, active: collection === Types_1.TemplateCollection.All, icon: react_1.default.createElement(icons_1.Folder, null) }),
                        react_1.default.createElement(Sidebar_1.SystemFolder, { dragDropOnFolder: function () { return onFolderDrop(Types_1.TemplateCollection.Archived); }, onFolderSelect: function () { return setTemplateCollection(Types_1.TemplateCollection.Archived); }, name: (0, Types_1.toTemplateCollectionDisplayName)(Types_1.TemplateCollection.Archived), collection: Types_1.TemplateCollection.Archived, active: collection === Types_1.TemplateCollection.Archived, disable: dragTemplate ? dragTemplate.fromCollection === Types_1.TemplateCollection.Deleted : false, icon: react_1.default.createElement(icons_1.Archive, null) }),
                        react_1.default.createElement(Sidebar_1.SystemFolder, { dragDropOnFolder: function () { return onFolderDrop(Types_1.TemplateCollection.Deleted); }, onFolderSelect: function () { return setTemplateCollection(Types_1.TemplateCollection.Deleted); }, name: (0, Types_1.toTemplateCollectionDisplayName)(Types_1.TemplateCollection.Deleted), collection: Types_1.TemplateCollection.Deleted, active: collection === Types_1.TemplateCollection.Deleted, disable: dragTemplate
                                ? dragTemplate.template.accessControls.delete.status === Types_1.TemplateAccessControlStatus.NotAllowed
                                : false, icon: react_1.default.createElement(icons_1.Delete, null) })))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("dashboard__main", c()) },
                react_1.default.createElement("div", { className: c("header") },
                    react_1.default.createElement(FolderNameInput_1.FolderNameInput, { className: c("title"), isDisabled: true, folderName: (0, Types_1.toTemplateCollectionDisplayName)(collection), folderId: "system", maxLength: 100 }),
                    react_1.default.createElement(kaleidoscope_1.SearchInput, { className: c("search-input"), label: "", placeholder: "Search templates", value: searchTerm, onChange: onSearchTermChange, onClear: function () { return onSearchTermChange(""); } }),
                    react_1.default.createElement(kaleidoscope_1.Button, { onClick: handleCreateTemplate }, "Create blank template")),
                react_1.default.createElement("div", { className: c("filter-sort-area") },
                    react_1.default.createElement(TemplateFilter_1.TemplateFilter, { templatesWith: templatesWith, setTemplatesWith: setTemplatesWith, accountIntegrationsDataStore: accountIntegrationsDataStore, withCrmInfo: withCrmInfo, setCrmInfo: setCrmInfo, userList: userList, userFilter: userFilter, setUserFilter: setUserFilter, state: dashboardController.$state }),
                    react_1.default.createElement(TemplateSortBySelector_1.TemplateSortBySelector, { sortBy: sortBy, setSortBy: setSortBy, setSortDirection: setSortDirection, sortDirection: sortDirection, setPage: setPage })),
                react_1.default.createElement(InlineOnboarding_1.default, { title: "Welcome to the templates dashboard \uD83C\uDF89", description: react_1.default.createElement(react_1.default.Fragment, null,
                        "Here you can find, edit and organize the templates created by you and your team, or create new templates.",
                        " ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/208-adding-custom-templates#manage" }, "Read our help docs"),
                        " ",
                        "for more information."), imageThumbnail: "".concat(ASSETS_DIR, "Images/OnboaringTE.png"), promptId: PromptTypes_1.PromptId.TemplatesWelcome, enabled: true }),
                collection === Types_1.TemplateCollection.Deleted && (react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Note" }, "Deleted templates will be removed from your account after 30 days.")),
                react_1.default.createElement("div", { className: c("template-list-wrapper") },
                    react_1.default.createElement(TemplateList_1.TemplateList, __assign({}, templateListProps(collection)))),
                accountTemplates.pagination && accountTemplates.pagination.numberOfPages > Types_1.TEMPLATES_FIRST_PAGE && (react_1.default.createElement(kaleidoscope_1.Pagination, { onPreviousButtonClick: function () { return setPage(Math.max(page - 1, Types_1.TEMPLATES_FIRST_PAGE)); }, onNextButtonClick: function () { return setPage(page + 1); }, isPreviousButtonDisabled: page === Types_1.TEMPLATES_FIRST_PAGE, isNextButtonDisabled: !accountTemplates.pagination.hasNext },
                    "Page ",
                    page,
                    " of ",
                    accountTemplates.pagination.numberOfPages))),
            react_1.default.createElement("div", { className: c("drag-label") },
                react_1.default.createElement(DragLabel_1.default, { divRef: dragLabelRef, text: "1 template" })))));
};
exports.TemplateManagementDashboard = TemplateManagementDashboard;
